export interface QrFilterOption {
  id: number;
  name: string;
}

export const formatQrFilterOption = (qr: QrFilterOption): string =>
  `${qr.name} (${qr.id})`;
